import React from 'react';
import moment from 'moment';

const ActivityUpdates = ({ updates }) => {
  if (!updates || updates.length === 0) {
    return (
      <div className='text-center py-4'>
        <i className='fas fa-comments fa-2x text-muted mb-3'></i>
        <p className='text-muted'>No updates yet</p>
        <small className='text-muted'>
          Updates and comments will appear here
        </small>
      </div>
    );
  }

  return (
    <div className='activity-updates'>
      <div className='mb-3'>
        <small className='text-muted'>
          {updates.length} comment{updates.length !== 1 ? 's' : ''} total
        </small>
      </div>
      {updates
        .slice() // Create a copy to avoid mutating the original array
        .reverse() // Show newest comments first
        .map((update, index) => (
          <div
            key={update._id || `${update.created_at}-${index}`}
            className='update-item mb-3'
          >
            <div className='d-flex'>
              <div
                className='avatar-circle me-3 d-flex align-items-center justify-content-center bg-primary text-white rounded-circle'
                style={{ width: '40px', height: '40px' }}
              >
                <i className='fas fa-user'></i>
              </div>

              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start mb-2'>
                  <div>
                    <strong className='text-primary'>
                      {update.created_by?.name || 'Unknown User'}
                    </strong>
                    {update.campaigns_completed !== undefined && (
                      <span className='ms-2 badge bg-info small'>
                        {update.campaigns_completed} campaigns completed
                      </span>
                    )}
                  </div>
                  <small className='text-muted'>
                    {moment(update.created_at).format('MMM DD, HH:mm')}
                  </small>
                </div>

                <div className='update-content bg-light p-3 rounded border'>
                  <p className='mb-0'>{update.comment}</p>
                </div>

                <small className='text-muted'>
                  {moment(update.created_at).fromNow()}
                </small>
              </div>
            </div>

            {index < updates.length - 1 && <hr className='my-3' />}
          </div>
        ))}
    </div>
  );
};

export default ActivityUpdates;
